module.exports = __webpack_public_path__ + "static/media/logonamehd.a26aa7f6.png";